import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Pagination, SearchBar } from "../../components";
import {
  fetchDebtAllUser,
  getAllPaymet,
  getAllTransaksionet,
  payDebtDriveSchool,
  resetPay,
  setPage,
} from "../../store/slices/debtSlice";
import { FaRegCircleXmark } from "react-icons/fa6";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  formatDateString,
  getCurrentDateTime,
  getFutureDateTime,
} from "../../util/time";
import {
  activeUserGuest,
  refusePaymentWithCashTwo,
} from "../../store/slices/userDriveSchoolSlice";

const TableTransaksionet = ({ status }) => {
  const dispatch = useDispatch();

  const payDebtStatus = useSelector((state) => state.debt.payDebtStatus);
  const loadingReset = useSelector((state) => state.debt.loadingResetPay);
  const transaksion = useSelector((state) => state.debt.transaksionet);
  const totalCount = useSelector((state) => state.debt.totalCount);
  const currentPage = useSelector((state) => state.debt.currentPage);
  const [searchInput, setSearchInput] = useState("");

  const [userId, setUserId] = useState("");
  const [amount, setAmount] = useState("");
  const [open, setOpen] = useState(false);
  const [openResetModal, setOpenResetModal] = useState(false);
  const [id, setId] = useState(0);
  const prevSearchRef = useRef("");

  useEffect(() => {
    const pageToUse = prevSearchRef.current !== searchInput ? 1 : currentPage;

    if (prevSearchRef.current !== searchInput) {
      dispatch(setPage(1));
      prevSearchRef.current = searchInput;
    }
  
    dispatch(getAllTransaksionet({ page: pageToUse, searchQuery: searchInput, status }));
  }, [dispatch, currentPage, searchInput, status]);
  

  useEffect(() => {
    dispatch(fetchDebtAllUser());
    dispatch(getAllPaymet());
  }, [payDebtStatus, loadingReset]);

  const onSubmit = (e) => {
    e.preventDefault();
    const data = { userId, amount };
    try {
      dispatch(payDebtDriveSchool(data));
      setAmount("");
      toast.success("Pagesa shkoi me sukses");
    } catch (error) {
      console.log(error);
    }
  };

  const resetPayment = (id) => {
    try {
      dispatch(resetPay(id));
      toast.success("Te dhenat jane freskuar me sukses");
    } catch (error) {
      console.log(error);
    }
  };

  const openResetModalFunction = (id) => {
    setId(id);
    setOpenResetModal(!openResetModal);
  };

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    dispatch(
      getAllTransaksionet({ page: currentPage, searchQuery: searchInput, status })
    );
  };

  const handlePageChange = (page) => {
    dispatch(setPage(page));
  };

  const handelActiveUser = (id, userId, catId, driveSchoolId, month) => {
    const data = {
      id,
      userId,
      catId,
      activeStart: getCurrentDateTime(),
      activeEnd: getFutureDateTime(month),
      driveSchoolId,
    };
    dispatch(activeUserGuest(data));
    toast.success("Kandidati u aktivizua me sukses");
  };
  const handleRefuse = (paymentId, catId, packageId) => {
    dispatch(refusePaymentWithCashTwo({ paymentId, catId, packageId })).then(
      () => {
        dispatch(
          getAllTransaksionet({ page: currentPage, searchQuery: searchInput })
        );
        toast.error("Kandiadti u refuzua");
      }
    );
  };

  return (
    <div className="p-3">
      <div className="flex flex-col sm:flex-row items-center justify-between pb-4 bg-white dark:bg-gray-900">
        <SearchBar
          searchInput={searchInput}
          handleSearchInputChange={handleSearchInputChange}
          handleSearchSubmit={handleSearchSubmit}
        />
      </div>
      <div
        className="relative overflow-x-auto shadow-md sm:rounded-lg"
        style={{ borderRadius: 1 }}
      >
        <div className="hidden sm:block">
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left text-gray-500 table-fixed">
              <thead className="text-xs bg-gray-50 text-[#718EBF]">
                <tr>
                  <th className="px-4 py-1 whitespace-normal">
                    Data e <br /> transaksionit
                  </th>
                  <th className="px-4 py-1 whitespace-normal">
                    Emri dhe <br /> mbiemri
                  </th>
                  <th className="px-4 py-1 whitespace-normal">Autoshkolla</th>
                  <th className="px-4 py-1 whitespace-normal">Kategoria</th>
                  <th className="px-4 py-1 whitespace-normal">Pako</th>
                  <th className="px-4 py-1 whitespace-normal">
                    Mënyra e <br /> pagesës
                  </th>
                  <th className="px-4 py-1 whitespace-normal">
                    Për <br /> pagesë
                  </th>
                  <th className="px-4 py-1 whitespace-normal">Statusi</th>
                  <th className="px-4 py-1 whitespace-normal">Bilanci</th>
                  <th className="px-4 py-2 w-52">Aksionet</th>
                </tr>
              </thead>
              <tbody>
                {transaksion?.data?.map((item) => (
                  <tr
                    key={item.id}
                    className="bg-white border-b hover:bg-gray-50 h-16"
                  >
                    <td
                      className="px-2 py-2 truncate whitespace-normal"
                      title={formatDateString(item.payment_date)}
                    >
                      {formatDateString(item.payment_date).split(" ")[0]}
                      <br />
                      {formatDateString(item.payment_date).split(" ")[1]}
                    </td>
                    <td
                      className="px-2 py-2 truncate whitespace-normal"
                      title={item.name}
                    >
                      {item.name &&
                        item.name.split(" ").map((part, idx, arr) => (
                          <React.Fragment key={idx}>
                            {part}
                            {idx < arr.length - 1}
                          </React.Fragment>
                        ))}
                    </td>
                    <td className="px-2 py-2 truncate " title={item.schoolName}>
                      {item.schoolName}
                    </td>
                    <td className="px-2 py-2 truncate " title={item.catName}>
                      {item.catName}
                    </td>
                    <td className="px-2 py-2 truncate " title={item.package}>
                      {item.package}
                    </td>
                    <td
                      className="px-2 py-2 truncate "
                      title={
                        item.cash === 1
                          ? "Para në dorë"
                          : "Përmes Kartelës së Bankës"
                      }
                    >
                      {item.cash === 1
                        ? "Para në dorë"
                        : "Përmes Kartelës së Bankës"}
                    </td>
                    <td
                      className="px-2 py-2 truncate "
                      title={`${item.amount}€`}
                    >
                      {item.amount}€
                    </td>
                    <td
                      className="px-2 py-2 truncate"
                      title={item.isActive === 1 ? "Aktivizuar" : "Në pritje"}
                    >
                      {item.isActive === 1 ? "Aktivizuar" : "Në pritje"}
                    </td>
                    <td
                      className="px-2 py-2 truncate"
                      title={`${item.remaining_balance} €`}
                    >
                      {item.remaining_balance} €
                    </td>
                    <td className="px-2 py-2">
                      <div className="gap-1 w-[full] justify-center items-center">
                        {item.user_id ? (
                          item.isActive ? (
                            <button className="bg-green-500 text-white font-bold py-2 px-4 rounded-full w-full">
                              Aktivizuar
                            </button>
                          ) : (
                            <div className="flex gap-1">
                              <button
                                onClick={() =>
                                  handelActiveUser(
                                    item.payment_id,
                                    item.user_id,
                                    item.category_id,
                                    item.driveSchool_id,
                                    item.month
                                  )
                                }
                                className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-full flex-1 min-w-[90px]"
                              >
                                Aktivizo
                              </button>
                              <button
                                onClick={() =>
                                  handleRefuse(
                                    item.payment_id,
                                    item.category_id,
                                    item.packageId
                                  )
                                }
                                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-full flex-1 min-w-[90px]"
                              >
                                Refuzo
                              </button>
                            </div>
                          )
                        ) : item.isActive ? (
                          <button className="bg-green-500 text-white font-bold py-2 px-4 rounded-full w-full">
                            Aktivizuar
                          </button>
                        ) : (
                          <button
                            onClick={() =>
                              handleRefuse(
                                item.category_id,
                                item.packageId,
                                item.user_id,
                                item.payment_id
                              )
                            }
                            className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-full w-full"
                          >
                            Refuzo
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="block sm:hidden space-y-4">
          {transaksion?.data?.map((item) => (
            <div
              key={item.id}
              className="bg-white shadow rounded-lg p-4 text-sm space-y-2"
            >
              <p>
                <strong>Data:</strong> {formatDateString(item.payment_date)}
              </p>
              <p>
                <strong>Emri:</strong> {item.name}
              </p>
              <p>
                <strong>Autoshkolla:</strong> {item.schoolName}
              </p>
              <p>
                <strong>Kategoria:</strong> {item.catName}
              </p>
              <p>
                <strong>Pako:</strong> {item.package}
              </p>
              <p>
                <strong>Mënyra e pagesës:</strong>{" "}
                {item.cash === 1 ? "Para në dorë" : "Përmes Kartelës së Bankës"}
              </p>
              <p>
                <strong>Për pagesë:</strong> {item.amount}€
              </p>
              <p>
                <strong>Statusi:</strong>{" "}
                {item.isActive === 1 ? "Aktivizuar" : "Në pritje"}
              </p>
              <p>
                <strong>Bilanci:</strong> {item.remaining_balance}€
              </p>
              <div className="flex flex-wrap gap-2">
                <td className="px-6 py-4 ">
                  {item.user_id ? (
                    item.isActive ? (
                      <button className="bg-green-500  text-white font-bold py-2 px-4 rounded-full">
                        Aktivizuar
                      </button>
                    ) : (
                      <>
                        <button
                          onClick={() =>
                            handelActiveUser(
                              item.payment_id,
                              item.user_id,
                              item.category_id,
                              item.driveSchool_id,
                              item.month
                            )
                          }
                          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-full mb-2"
                        >
                          Aktivizo
                        </button>
                        <button
                          onClick={() =>
                            handleRefuse(
                              item.payment_id,
                              item.category_id,
                              item.packageId
                            )
                          }
                          className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4  rounded-full"
                        >
                          Refuzo
                        </button>
                      </>
                    )
                  ) : item.isActive ? (
                    <button className="bg-green-500  text-white font-bold py-2 px-4 rounded-full">
                      Aktivizuar
                    </button>
                  ) : (
                    <button
                      onClick={() =>
                        handleRefuse(
                          item.category_id,
                          item.packageId,
                          item.user_id,
                          item.payment_id
                        )
                      }
                      className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4  rounded-full"
                    >
                      Refuzo
                    </button>
                  )}
                </td>
              </div>
            </div>
          ))}
        </div>

        <Pagination
          currentPage={currentPage}
          totalCount={totalCount}
          onPageChange={handlePageChange}
        />
      </div>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-15">
          <div className="bg-gray-900 bg-opacity-40 absolute inset-0"></div>
          <div
            className="relative bg-white rounded-lg shadow-lg"
            style={{ width: "420px" }}
          >
            <button
              type="button"
              onClick={() => setOpen(!open)}
              className="absolute top-3 right-3 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-full w-8 h-8 flex justify-center items-center"
            >
              <FaRegCircleXmark style={{ width: 20, height: 20 }} />
            </button>

            <div className="p-6 text-center">
              <h3 className="mb-5 text-xl font-normal text-gray-500 dark:text-gray-400">
                Paguaj
              </h3>
              <form className="space-y-6 text-start" onSubmit={onSubmit}>
                <div>
                  <label
                    htmlFor="input2"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Shuma
                  </label>
                  <input
                    type="number"
                    name="amount"
                    id="amount"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder=""
                    required
                  />
                  <div className="flex justify-center">
                    <div className="flex items-center mt-5">
                      <button
                        type="submit"
                        className="text-white bg-blue-500 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 mr-2 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                      >
                        Paguaj
                      </button>

                      <button
                        data-modal-hide="popup-modal"
                        type="button"
                        onClick={() => setOpen(!open)}
                        className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                      >
                        Anulo
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {openResetModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-15">
          <div className="bg-gray-900 bg-opacity-40 absolute inset-0"></div>
          <div
            className="relative bg-white rounded-lg shadow-lg"
            style={{ width: "420px" }}
          >
            <button
              type="button"
              onClick={() => setOpenResetModal(!openResetModal)}
              className="absolute top-3 right-3 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-full w-8 h-8 flex justify-center items-center"
            >
              <FaRegCircleXmark style={{ width: 20, height: 20 }} />
            </button>

            <div className="p-6 text-center">
              <h3 className="mb-5 text-xl font-normal text-gray-500 dark:text-gray-400">
                A jeni i sigurt?
              </h3>
              <button
                className="bg-red-500 rounded-full text-white px-4 py-2"
                onClick={() => resetPayment(id)}
              >
                Reseto
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TableTransaksionet;
